import { BaseCarousel, type BaseCarouselConfig } from '../base-carousel';

export class RgsCarousel extends BaseCarousel {
  protected getDefaultConfig(): BaseCarouselConfig {
    return {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      pagination: true,
      navigation: true,
      mousewheel: true
    };
  }
}

const rgsCarousel = new RgsCarousel();

export function initAllRgsCarousels(): void {
  rgsCarousel.init('.rgs-carousel-general-img-list-promo');
  rgsCarousel.init('.rgs-carousel-block');
}

export { rgsCarousel };
